import React from 'react';
import { Label } from '@flexiflow-ui-kit/label';
import { Hint } from '@flexiflow-ui-kit/hint';
import { ArrowDownIcon, CheckedIcon } from '@flexiflow-ui-kit/icon';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import styled, { css } from 'styled-components';
import { Menu as Menu$1, MenuButton as MenuButton$1, MenuList as MenuList$1, MenuItem as MenuItem$1 } from '@reach/menu-button';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var BadgeMenuOptionType;

(function (BadgeMenuOptionType) {
  BadgeMenuOptionType["Default"] = "default";
  BadgeMenuOptionType["Success"] = "success";
  BadgeMenuOptionType["Danger"] = "danger";
})(BadgeMenuOptionType || (BadgeMenuOptionType = {}));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _menuButtonStyle, _templateObject8, _templateObject9, _templateObject10;
var Menu = styled(Menu$1)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var menuButtonStyle = (_menuButtonStyle = {}, _defineProperty(_menuButtonStyle, BadgeMenuOptionType.Default, {
  normal: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      color: ", ";\n      background-color: ", ";\n    "])), function (p) {
    return p.theme.palette.black;
  }, function (p) {
    return p.theme.palette.gray['200'];
  }),
  hover: css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      color: ", ";\n      background-color: ", ";\n    "])), function (p) {
    return p.theme.palette.black;
  }, function (p) {
    return p.theme.palette.gray['400'];
  })
}), _defineProperty(_menuButtonStyle, BadgeMenuOptionType.Success, {
  normal: css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      color: ", ";\n      background-color: ", ";\n    "])), function (p) {
    return p.theme.palette.white;
  }, function (p) {
    return p.theme.palette.green['500'];
  }),
  hover: css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      color: ", ";\n      background-color: ", ";\n    "])), function (p) {
    return p.theme.palette.white;
  }, function (p) {
    return p.theme.palette.green['700'];
  })
}), _defineProperty(_menuButtonStyle, BadgeMenuOptionType.Danger, {
  normal: css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      color: ", ";\n      background-color: ", ";\n    "])), function (p) {
    return p.theme.palette.white;
  }, function (p) {
    return p.theme.palette.red['700'];
  }),
  hover: css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      color: ", ";\n      background-color: ", ";\n    "])), function (p) {
    return p.theme.palette.white;
  }, function (p) {
    return p.theme.palette.red['800'];
  })
}), _menuButtonStyle);
var MenuButton = styled(MenuButton$1)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  border-radius: 4px;\n  padding: 5px 8px;\n  font-size: 12px;\n  line-height: 14px;\n  width: auto;\n  height: 24px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  ", ";\n\n  :hover {\n    ", ";\n  }\n\n  :disabled {\n    background-color: ", ";\n    color: ", ";\n    cursor: not-allowed;\n  }\n"])), function (p) {
  return p.$isExpanded ? menuButtonStyle[p.$optionType].hover : menuButtonStyle[p.$optionType].normal;
}, function (p) {
  return [menuButtonStyle[p.$optionType].hover];
}, function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.theme.palette.gray['500'];
});
var MenuList = styled(MenuList$1)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.1));\n  border-radius: 4px;\n  width: auto;\n  height: auto;\n  margin-top: 4px;\n  margin-bottom: 4px;\n"])), function (p) {
  return p.theme.palette.white;
});
var MenuItem = styled(MenuItem$1)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  min-height: 32px;\n  padding: 9px 14px 9px 8px;\n  font-size: 12px;\n  line-height: 14px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  gap: 15px;\n  justify-content: space-between;\n  color: ", ";\n  background-color: ", ";\n\n  :first-child {\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n  }\n\n  :last-child {\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n\n  :hover {\n    background-color: ", ";\n  }\n"])), function (p) {
  return p.theme.palette.black;
}, function (p) {
  return p.theme.palette.white;
}, function (p) {
  return p.theme.palette.gray['100'];
});

function BadgeMenu(_ref) {
  var options = _ref.options,
      value = _ref.value,
      onChange = _ref.onChange,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      className = _ref.className,
      hint = _ref.hint,
      hintKeepPlace = _ref.hintKeepPlace,
      hintCanDisabled = _ref.hintCanDisabled,
      hasError = _ref.hasError,
      label = _ref.label,
      labelCanDisabled = _ref.labelCanDisabled,
      labelCount = _ref.labelCount,
      labelMaxCount = _ref.labelMaxCount;
  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(Label, {
    label: label,
    labelCanDisabled: labelCanDisabled,
    disabled: disabled,
    labelCount: labelCount,
    labelMaxCount: labelMaxCount
  }, /*#__PURE__*/React.createElement(Hint, {
    hint: hint,
    hintKeepPlace: hintKeepPlace,
    hintCanDisabled: hintCanDisabled,
    hasError: hasError,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Menu, null, function (_ref2) {
    var isExpanded = _ref2.isExpanded;
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement(MenuButton, {
      disabled: disabled,
      className: "badge-menu__button",
      $isExpanded: isExpanded,
      type: "button",
      $optionType: value.type || BadgeMenuOptionType.Default
    }, value.label, " ", /*#__PURE__*/React.createElement(ArrowDownIcon, {
      width: 8,
      height: 5
    })), /*#__PURE__*/React.createElement(MenuList, {
      className: "badge-menu__list"
    }, options.map(function (option, index) {
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: index,
        $isSelected: option.value === value.value,
        onSelect: function onSelect() {
          return onChange(option);
        },
        className: "badge-menu__item"
      }, option.label, ' ', option.value === value.value && /*#__PURE__*/React.createElement(CheckedIcon, {
        width: 12,
        height: 9
      }));
    })));
  }))));
}

export { BadgeMenu, BadgeMenuOptionType };
